import React from 'react';

import { AssignedTeamMember } from 'components/prequalification/prequalification.dto';
import TeamMembers from 'components/prequalification/EntryFormResult/Slides/TeamMembers';
import styles from 'components/prequalification/EntryFormResult/EntryFormResult.module.scss';

interface ExistingIntermediaryProps {
  assignedTeamMember: AssignedTeamMember;
}

const ExistingIntermediary = ({ assignedTeamMember }: ExistingIntermediaryProps) => {
  return (
    <div>
      <div className={styles.textBlock}>
        <p className={styles.text}>
          The company you are trying to register already exists. To resolve this issue, please contact your
          administrator or your current HFS Representative for assistance.
        </p>
      </div>
      <TeamMembers
        name={assignedTeamMember.name}
        email={assignedTeamMember.email}
        phone={assignedTeamMember.phone}
        position={assignedTeamMember.position}
        isDefault={assignedTeamMember.isDefault}
      />
    </div>
  );
};

export default ExistingIntermediary;
